import { create } from "zustand";
import { sendOtp, verifyOtp } from "../../apiEndpoints/navutils";

type ForgotState = {
    // state
    otpEntryValue: string;
    showLoading: boolean;

    // actions
    setEntryValue: (value: string) => void;
    verifyOtp: (email: string, taskCompleted: () => void) => Promise<void>;
    toggleLoading: () => void;
};

export const useForgotStore = create<ForgotState>((set, get) => ({
    // initial state
    otpEntryValue: "",
    showLoading: false,

    // set OTP value
    setEntryValue: (value: string) =>
        set({ otpEntryValue: value }),

    // toggle loading
    toggleLoading: () =>
        set((state) => ({ showLoading: !state.showLoading })),

    // verify OTP
    verifyOtp: async (email, taskCompleted) => {
        set({ showLoading: true })
        const { otpEntryValue } = get();
        const result = await verifyOtp(email, otpEntryValue);
        set({ showLoading: false })
        if (result) {
            taskCompleted()
        }
    },
}));